import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import GlobelStore from "../../../Store/GlobelStore";

const ClientWorkHoursWidget = observer(() => {
  const [total, setTotal] = useState(0);

  useEffect(() => {
    const clientData = GlobelStore?.dashboardAllData?.allClientTotalApprovedHrs;

    if (clientData) {
      setTotal(clientData);
    }
  }, [GlobelStore?.dashboardAllData?.allClientTotalApprovedHrs]);
  return (
    <div className="notificationContainer clientWidgetContainer">
      <div className="clienWidgetTitle">Total Client Approved Hours</div>
      <div className="clientWidgetSubTitle">{total} </div>
    </div>
  );
});

export default React.memo(ClientWorkHoursWidget);
